export class ConsultationRequestError extends Error {
  public constructor(message: string) {
    super(message);
    this.name = 'ConsultationRequestError';
  }
}
